import { defineCustomElements } from '@arcgis/map-components/dist/loader';
defineCustomElements(window); // <-- Load ArcGIS web components first

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
